import { SocialIcons } from "./SocialIcons";

export const Footer = ({ t }) => (
  <footer data-testid="footer" className="border-t border-white/10 py-12">
    <div className="mx-auto max-w-7xl px-6">
      <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
        <div className="flex items-center gap-2.5">
          <img src="/gta-logo-icon.jpeg" alt="GTA logo" className="h-8 w-8 rounded-lg border border-[#EAB308]/40 object-cover" />
          <span className="font-['Outfit'] font-bold">Global Trading Academy</span>
        </div>
        <SocialIcons />
      </div>
      <p data-testid="footer-risk-warning" className="mt-8 max-w-4xl text-xs leading-relaxed text-gray-600">
        {t.footer.risk}
      </p>
      <p className="mt-4 text-xs text-gray-600">© {new Date().getFullYear()} {t.footer.rights}</p>
    </div>
  </footer>
);
